module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/pedidos"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-purple",
      "icon": "ion ion-alert"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("PEDIDOS NOVOS")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.novosPedidos))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiDelivery) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/pedidos"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-aqua",
      "icon": "ion ion-ios-cart-outline"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("TODOS OS PEDIDOS")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.totalPedidos))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/calendario"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-red",
      "icon": "ion ion-calendar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("AGENDAMENTOS DE HOJE")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.agendamentosHoje))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiAgendamento) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/calendario"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-red",
      "icon": "ion ion-calendar"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("TODOS AGENDAMENTOS")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.todosAgendamentos))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/solicitacoes"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-red",
      "icon": "ion ion-alert"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("SOLICITAÇÕES PENDENTES")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.solicitacoesPendentes))])])], 1) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/solicitacoes"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-red",
      "icon": "ion ion-ios-cart-outline"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("TODAS SOLICITAÇÕES")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.todasSolicitacoes))])])], 1) : _vm._e(), _vm._v(" "), _c('info-box', {
    staticClass: "offset-md-3",
    attrs: {
      "colorIcon": "bg-green",
      "icon": "ion-chatbubbles"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("Atendimentos")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.atendimentos))])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink linkRota",
    attrs: {
      "to": "/clientes"
    }
  }, [_c('info-box', {
    attrs: {
      "colorIcon": "bg-yellow",
      "icon": "ion ion-ios-people-outline"
    }
  }, [_c('span', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("CLIENTES")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "info"
    },
    slot: "info"
  }, [_vm._v(_vm._s(_vm.clientes) + " ")])])], 1)], 1), _vm._v(" "), (_vm.possuiDelivery) ? _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('Circle8', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [(_vm.config.notifica_cliente) ? _c('div', {
    staticClass: "col-sm-6 col-xs-12 previsaoEntrega"
  }, [_c('p', {
    staticClass: "text-center paragrafo"
  }, [_c('strong', [_vm._v("Previsao de entrega")])]), _vm._v(" "), _c('div', {
    staticClass: "row slider"
  }, [_c('vue-slider', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.tempo_entrega),
      callback: function($$v) {
        _vm.tempo_entrega = $$v
      },
      expression: "tempo_entrega"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row btnEntrega"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravar && !_vm.gravando),
      expression: "gravar && !gravando"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.gravarEntrega
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary disabled"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "visible-xs-block"
  }), _vm._v(" "), _c('div', {
    class: [_vm.config.notifica_cliente ? 'col-sm-6 col-xs-12' : 'col-sm-6 col-xs-12 col-sm-offset-3']
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_c('strong', [_vm._v("Ranking de Produtos")]), _c('br'), _vm._v("\n                Comparativo dos três produtos mais vendidos.\n              ")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "languagePie"
    }
  })])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.possuiTurismo) ? _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('Circle8', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_c('strong', [_vm._v("Escolhas Preferidas")]), _c('br'), _vm._v("\n                As principais respostas recebidas\n              ")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "tagsPreferidas"
    }
  })])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1669b7e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 1207
// module chunks = 1